import styled from 'styled-components';

export const VolumeIndicatorWrapper = styled.div`
    margin-top: 8px;
`;

export const MicTestButtonWrapper = styled.div`
    margin-top: 8px;
`;
